import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

// ------------------ COMPONENTES DE BASE --------------------------------
import Card from "../../../../Base/Components/Card/Card";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";

// ------------------- CONSULTAS A LA API --------------------------------
import { getVehiculos } from "../../../../API/Global/Vehiculos/VehiculosRequest";

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import VehiculosCRUD from "./VehiculosCRUD";

export const VehiculosScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  const getInfo = async () => {
    setLoading(true);
    const dataTempo = await getVehiculos();
    setData(dataTempo);
    setLoading(false);
  };

  const colums = [
    {
      field: "IdVehiculo",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      frozen: true,
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Marca",
      header: "Marca",
      headerEn: "Marca",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
      setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Modelo",
      header: "Modelo",
      headerEn: "Modelo",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Serie",
      header: "Serie",
      headerEn: "Serie",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Placa",
      header: "Placa",
      headerEn: "Placa",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: true,
      className: "Xsmall",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "Type",
      header: "Tipo Vehículo",
      headerEn: "Type",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "ColorEs",
      header: "Color",
      headerEn: "Color",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
    },

    {
      field: "IdVehiculo",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: data,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "vehiculos", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast}></Toast>
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "vehiculos", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && <VehiculosCRUD toastRef={toast} showDialog={showDialog} selected={selected} setShowDialog={setShowDialog} getInfo={getInfo} modo={selected ? "Editar" : "Crear"}/>}
    </div>
  );
};

export default VehiculosScreen;
